<ng-container *ngIf="!confirm">
    <h2>{{title}}</h2>
  
    <form id="addUserForm" [formGroup]="addUserForm" (ngSubmit)="onSubmit()">
  
      <mat-form-field appearance="outline">
        <mat-label>Nom</mat-label>
        <input matInput type="text" formControlName="lastName" [required]="true">
      </mat-form-field>
  
      <mat-form-field appearance="outline">
        <mat-label>Prénom</mat-label>
        <input matInput type="text" formControlName="firstName" [required]="true">
      </mat-form-field>
  
      <mat-form-field appearance="outline">
        <mat-label>Téléphone</mat-label>
        <input matInput type="tel" formControlName="phone" [required]="true" appNumbersOnly>
      </mat-form-field>
  
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email">
      </mat-form-field>
      
    </form>
  
    <p class="required">* Champ requis</p>
    
    <div class="btn_action">
      <button class="back" (click)="dialogRef.close()">Annuler</button>
      <button class="confirm" form="addUserForm" [disabled]="addUserForm.invalid" [style.opacity]="addUserForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">{{btnConfirm}}</button>
    </div>

</ng-container>

<app-validation-animation *ngIf="confirm" [text]="'Utilisateur ajouté'"></app-validation-animation>